import React from "react"
import {
  Input,
  Currency,
  FormControl,
  InputAdornment,
  InputLabel,
} from "@fedsim/components"
import { Controller } from "react-hook-form"

export const FormCurrency = ({ name, control, label, size = "small" }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={props => CurrencyUI({ ...props, label, size })}
    />
  )
}

const CurrencyUI = ({
  label,
  size,
  field: { onChange, value },
  fieldState: { error },
}) => {
  const changeHandler = event => onChange(event.target.value)

  return (
    <FormControl fullWidth variant='standard'>
      <InputLabel htmlFor='standard-adornment-amount'>{label}</InputLabel>
      {error && error.message}
      <Input
        id='standard-adornment-amount'
        value={value}
        type='number'
        size={size}
        onChange={changeHandler}
        startAdornment={
          <InputAdornment position='start'>
            <Currency>¤</Currency>
          </InputAdornment>
        }
      />
    </FormControl>
  )
}
